<template>
  <div class="w3-col w3-left-align">
    <ContentHeader v-bind:title="$t('visitor-report')"></ContentHeader>
  </div>

  <ReportTemplate>
    <template #actions >
      <DatePicker :day="$helper.today()" @emitted-day="onDateUpdate" />
      <ExportButton :columns="pdfColumns" :objects="officeVisitors" :file-name="$t('visitor-report_')" />
    </template>
    <StandardTable
      :sort-options="true"
      :no-content="'noData'"
      :column-definitions="columnDefinitions"
      :records="officeVisitors"
    />
  </ReportTemplate>
</template>

<script>
import ContentHeader from "../../common/ContentHeader";
import StandardTable from "../../common/StandardTable.vue";
import DatePicker from "./report-templates/actions/DatePicker.vue";
import ExportButton from "./report-templates/actions/ExportButton.vue"
import ReportTemplate from "./report-templates/ReportTemplate.vue";

export default {
  name: "VisitorReport",
  components: { ContentHeader, ReportTemplate, StandardTable, DatePicker, ExportButton },

  data() {
    return {
      officeVisitors: [],
      columnDefinitions: [
        { key: "id", label: "id", dataKey: "id" },
        {
          key: "name",
          label: this.$t("name"),
          dataKey: "name",
        },
        {
          key: "email",
          label: this.$t("email"),
          dataKey: "email",
        },
        {
          key: "phone",
          label: this.$t("phone"),
          dataKey: "phone",
        },
        {
          key: "company",
          label: this.$t("company"),
          dataKey: "company",
        },
        {
          key: "contact",
          label: this.$t("contact"),
          dataKey: "contact",
        },
        {
          key: "appointmentTime",
          label: this.$t("appointmentTime"),
          dataKey: "appointmentTime",
        },
        {
          key: "arrivalTime",
          label: this.$t("arrivalTime"),
          dataKey: "arrivalTime",
        },
      ],
      pdfColumns: [
        { title: "id", dataKey: "id" },
        { title: this.$t("name"), dataKey: "name" },
        { title: this.$t("email"), dataKey: "email" },
        { title: this.$t("phone"), dataKey: "phone" },
        { title: this.$t("company"), dataKey: "company" },
        { title: this.$t("contact"), dataKey: "contact" },
        { title: this.$t("appointmentTime"), dataKey: "appointmentTime" },
        { title: this.$t("arrivalTime"), dataKey: "arrivalTime" },
      ],
    };
  },
  mounted() {
    const day = this.$helper.today();
    this.onDateUpdate(day);
  },
  methods: {
    onDateUpdate(day) {
      const queryString = `day=${this.$helper.flipDateFormat(
        day
      )}`;
      this.getAllVisitorsPerDay(queryString);
    },
    getAllVisitorsPerDay(queryString) {
      this.$restClient.visitors
        .getVisitors({ query: queryString })
        .then((response) => {
          this.officeVisitors = this.mappedVisitors(response.data);
        })
        .catch((err) => {
          console.log(err);
          this.$notify.notifyError({ title: this.$t("failed") });
        });
    },
    mappedVisitors(data) {
      let index = 1;
      const records = data.map((v) => ({
        id: index++,
        name: `${v.lastName} ${v.firstName}`,
        email: v.email,
        phone: v.phoneNumber,
        company: v.company,
        contact: `${v.contactLastName} ${v.contactFirstName}`,
        appointmentTime: `${v.appointmentDate} ${v.appointmentTime}`,
        arrivalTime: `${v.arrivalDate} ${v.arrivalTime}`,
      }));
      return records;
    },
  },
};
</script>

<style scoped>
.table-header-row:hover {
  background-color: white;
}
</style>
